import script from "./Heading1.vue?vue&type=script&setup=true&lang=js"
export * from "./Heading1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__